import { combineReducers } from 'redux'
import dataReducer from 'lib/reducers/dataReducer'
import requestStateReducer from 'lib/reducers/requestStateReducer'
import { supplyOrdersSearchTypes } from 'actions/types'

const initialState = []
const baseType = supplyOrdersSearchTypes.SEARCH_SUPPLY_ORDERS

const reducer = combineReducers({
  data: dataReducer({ initialState, baseType }),
  requestState: requestStateReducer(baseType),
})

export default reducer
